import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import config from '../../config';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  Page,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  ReturnsAndRefunds,
  Footer,
  LayoutSingleColumn,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import ExternalLink from '../../components/ExternalLink/ExternalLink';
import FAQAccordion from '../../containers/FAQPage/FAQAccordion/FAQAccordion';
import css from './ReturnsAndRefundsPage.module.css';

const ReturnsAndRefundsPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage(
    { id: 'ReturnsAndRefundsPage.schemaTitle' },
    { siteTitle }
  );
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="ReturnsAndRefundsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="ReturnsAndRefundsPage.heading" />
            </h1>
            <h4>Returns & Refunds – For Fan Buyers</h4>
        <FAQAccordion
          question={`What is Fave’s returns and refunds policy for buyers?`}
        >
          <p>
            Fave is a fan-powered platform, and each Merch Maker sets their own
            return and refund policies. That means:<br />
            <b>• Returns are not guaranteed</b>
            <br />
            <b>• Refunds are only processed if the seller agrees</b>
            <br />
            <b>• Each seller defines their own policy</b>
            <br />
            <b>• Fave steps in only after you’ve contacted the seller</b>
            <br />
            Always check a shop’s return policy before you buy. If something
            goes wrong, message the seller first. If you don’t hear back, reach
            out to us at{' '}
            <ExternalLink href={'mailto:marketplace@faveforfans.com'}>
              marketplace@faveforfans.com
            </ExternalLink>
            .
          </p>
        </FAQAccordion>
        <FAQAccordion question={`Can I return something I bought on Fave?`}>
          <p>
            Maybe. Some sellers accept returns, but many don’t—especially for
            custom or made-to-order items. You can find the seller’s return
            policy in their <b>Shop Details</b> on the Fave app.
          </p>
        </FAQAccordion>
        <FAQAccordion question={`How do I request a return or refund?`}>
          <p>
            Message the seller directly from your order page. If they agree to a
            refund or return, they’ll walk you through next steps (like where to
            send the item and who covers shipping).{' '}
          </p>
        </FAQAccordion>

        <FAQAccordion question={`Do all sellers accept returns?`}>
          <p>
            No. Each shop decides their own policy, and many do not accept
            returns unless the item is damaged or incorrect. Always check before
            purchasing.
          </p>
        </FAQAccordion>
        <FAQAccordion
          question={`What if the seller doesn’t respond to my message?`}
        >
          <p>
            If you’ve reached out and haven’t heard back, contact us at{' '}
            <ExternalLink href={'mailto:marketplace@faveforfans.com'}>
              marketplace@faveforfans.com{''}
            </ExternalLink>
            . We’ll do our best to help—but refunds still depend on the seller’s
            agreement.
          </p>
        </FAQAccordion>
        <FAQAccordion
          question={`How does the refund process work?
`}
        >
          <p>
            Once a refund is approved by the seller:
            <br />
            1. The seller emails Fave with your order details. <br />
            2. We process the refund using your original payment method.
            <br />
            3. You’ll receive confirmation once it’s complete.{' '}
          </p>
        </FAQAccordion>

      <p className={css.lastUpdated}>Last updated: May, 24th 2022</p>
     
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

ReturnsAndRefundsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const ReturnsAndRefundsPage = compose(
  connect(mapStateToProps),
  injectIntl
)(ReturnsAndRefundsPageComponent);

export default ReturnsAndRefundsPage;
